import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "main-content-container" };
const _hoisted_2 = { class: "card bg-white border-0 rounded-10 mb-30 p-25" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_BreadCrumb = _resolveComponent("BreadCrumb");
    const _component_VabeneClosureCalendar = _resolveComponent("VabeneClosureCalendar");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_BreadCrumb, {
            PageTitle: _ctx.$t('pages.restaurantClosures')
        }, null, 8, ["PageTitle"]),
        _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_VabeneClosureCalendar)
        ])
    ]));
}
